<template>
  <div>

    <div
      v-show="coords"
      id="map"
      ref="map"
      :style="'height: ' + heightCard"
      class="map">
      <v-layout
        v-if="!(coords && coords.length > 0)"
        align-center
        justify-center
        column>
        <h5>{{ strings[idioma].carregando }}</h5>
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate />
      </v-layout>
    </div>
    <div
      id="popup"
      class="ol-popup">
      <a
        id="popup-closer"
        href="#"
        class="ol-popup-closer"/>
      <div id="popup-content"/>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import 'ol/ol.css'
import Feature from 'ol/Feature'
import Map from 'ol/Map'
import Point from 'ol/geom/Point'
import View from 'ol/View'
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text
} from 'ol/style'
import { Cluster, OSM, Vector as VectorSource } from 'ol/source'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
import { createMD5 } from '@/utils/utils'
import { toStringHDMS } from 'ol/coordinate'
import XYZ from 'ol/source/XYZ'
import Overlay from 'ol/Overlay'
import { toLonLat } from 'ol/proj'
import moment from 'moment'
export default {
  name: 'GoogleMaps',
  data () {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null
    }
  },
  computed: {
    ...mapState('app', ['strings', 'coords', 'naoVinculados', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas', 'vinculados', 'alimentos_empresa', 'map']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 220) + 'px'
    }

  },
  watch: {
    map (val) {
      let self = this
      function isCluster (feature) {
        if (!feature || !feature.get('features')) {
          return false
        }
        return feature.get('features').length >= 1
      }
      let map = val
      map.on('click', function (evt) {
        console.log({ pixel: evt.pixel })
        var feature = map.forEachFeatureAtPixel(evt.pixel,
          function (feature) { return feature })
        if (isCluster(feature)) {
          var features = feature.get('features')
          let clientes = []
          let msg = ''
          for (var i = 0; i < features.length; i++) {
            let c = features[i].get('dados')
            clientes.push(c)
            if (features[i].get('type') === 'Vinculado') {
              msg += '<h4>' + c.NOME + ' (Vinculado)</h4>'
              msg += '<p>' + c.email + '</p>'
              if (c.cpf !== null) msg += '<p>' + c.cpf + '</p>'
              if (c.phone) msg += '<p v-if="currUser.phone">' + '+' + c.phone.cod_pais + '(' + c.phone.DDD + ')' + c.phone.telefone + '</p>'
              if (c.endereco) msg += '<p v-if="currUser.endereco">' + c.endereco.cidade + ' - ' + c.endereco.estado + ' - ' + c.endereco.pais + '</p>'
              msg += '<a target="_blank" href="/empresa/colaboradores?cid=' + c.id + '">' + self.strings[self.idioma].acessar + '</a>'
              msg += '<hr/>'
            } else {
              msg += '<h4>' + c.NOME + ' (Não Vinculado)</h4>'
              msg += '<p>' + c.email + ' - Fone: +' + c.cod_pais + ' (' + c.DDD + ') ' + c.telefone + '</p>'
              msg += '<i>' + c.cidade + ' - ' + c.estado + ' - ' + c.pais + '</i>'
              let i = 0
              for (let dieta of c.dietas) {
                let ativa = dieta.ativa
                let color = !dieta.ativa ? 'red' : 'green'
                let md5hash = createMD5(String(dieta.id))
                msg += '<p><a target="_blank" href="/formulacao-dieta?did=' + dieta.id + '&assinatura=' + md5hash + '">Dieta #' + dieta.id + ((ativa) ? '(ATIVA)' : '') + ' - ' + self.moment(dieta.updated_at).format(self.strings[self.idioma].formato_datas_sem_hora) + '</a></p>'
                msg += `<p style="color: blue">PCM: ${(dieta.peso_corporal_inicial + dieta.peso_corporal_final) / 2} kg - GMD: ${dieta.ganho_medio_diario} kg</p>`
                let iAlim = 0
                if (!dieta.alimentos) continue
                for (let alimento of dieta.alimentos) {
                  if (!alimento.alData[0]) continue
                  if (alimento.qtd > 0) {
                    iAlim++
                  }
                  if (alimento.qtd >= 1) {
                    msg += '<p><span style="color:' + color + '">' + alimento.alData[0]['nome'] + ' ---> ' + parseFloat(alimento.qtd).toFixed(2) + '/kg</span></p>'
                  } else if (alimento.qtd * 1000 >= 1) {
                    msg += '<p><span style="color:' + color + '">' + alimento.alData[0]['nome'] + ' ---> ' + parseFloat(alimento.qtd * 1000).toFixed(2) + '/g</span></p>'
                  } else if (alimento.qtd > 0.0001) {
                    msg += '<p><span style="color:' + color + '">' + alimento.alData[0]['nome'] + ' ---> ' + parseFloat((alimento.qtd * 1000) * 1000).toFixed(3) + '/mg</span></p>'
                  } else {
                    msg += '<p><span style="color:' + color + '">' + alimento.alData[0]['nome'] + ' ---> Apenas foi selecionado</span></p>'
                  }
                }
                msg += '<p>----------------------</p>'
                if (iAlim === 0) continue
                i++
              }
              if (i > 0) {
                msg += '<p>' + i + ' dieta(s) usando alimento(s) de empresa</p>'
              } else {
                msg += '<p>Alimento(s) de empresa foram selecionados, mas não foram utilizados nas dietas.</p>'
              }

              msg += '<hr/>'
            }
          }
          let title = ''
          self.$store.commit('openOKModal', { title, msg })
        }
      })
    },
    coords (val) {
      this.coordsChanged(val)
    }
  },

  mounted () {
    // this.geolocate()

  },

  methods: {
    coordsChanged (val) {
      const COLOR_VINCULADO = '#3399CC'
      const COLOR_NAO_VINCULADO = '#33cc4c'
      var count = 20000
      let features = []
      let e = 4500000

      for (let c of val) {
        let p = new Point([c[0], c[1]])
        let f = new Feature({ geometry: p })
        f.set('type', c[2]().vinculado ? 'Vinculado' : 'Não Vinculado')
        f.set('dados', c[2]())
        c[3] = f.values_.geometry.ol_uid
        features.push(f)
      }
      var source = new VectorSource({
        features: features
      })

      var clusterSource = new Cluster({
        distance: parseInt(30, 10),
        source: source
      })

      var styleCache = {}
      var clusters = new VectorLayer({
        source: clusterSource,
        style: function (feature) {
          var size = feature.get('features').length
          let tipos = {}
          for (let i = 0; i < size; i++) {
            let f = feature.get('features')[i]
            if (tipos[f.get('type')] === undefined) {
              tipos[f.get('type')] = 0
            }
            tipos[f.get('type')]++
          }
          var style = styleCache[size]
          if (true) {
            style = new Style({
              image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                  color: '#fff'
                }),
                fill: new Fill({
                  color: (tipos['Vinculado'] > 0) ? COLOR_VINCULADO : COLOR_NAO_VINCULADO
                })
              }),
              text: new Text({
                text: size.toString(),
                fill: new Fill({
                  color: '#fff'
                })
              })
            })
            styleCache[size] = style
          }
          return style
        }
      })
      var raster = new TileLayer({
        source: new OSM()
      })
      if (this.$store.state.app.map !== null) this.$store.state.app.map.dispose()
      this.$store.state.app.map = new Map({
        layers: [raster, clusters],
        target: 'map',
        view: new View({
          projection: 'EPSG:4326',
          center: [-44.38, -18.1],
          zoom: 3
        })
      })
    },
    toggleFull () {
      let wAtual = document.getElementById('map').clientHeight
      console.log(document.getElementById('map').clientHeight)
      document.getElementById('map').setAttribute('style', 'height:1000px')
      this.coordsChanged(this.coords)
    },
    moment (...args) {
      return moment(...args)
    },
    // receives a place object via the autocomplete component
    setPlace (place) {
      this.currentPlace = place
    },
    addMarker () {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        }
        this.markers.push({ position: marker })
        this.places.push(this.currentPlace)
        this.center = marker
        this.currentPlace = null
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    }
  }
}
</script>
